// extracted by mini-css-extract-plugin
export default {"bounce":"S_ff","loading":"S_fg","logo-mark-bounce-right":"S_fh","logo-mark-bounce-left":"S_fj"};